import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Slide from "@material-ui/core/Slide";
import ShowMoreText from "react-show-more-text";
import Select from "@material-ui/core/Select";
import CustomTextField from "@components/Global/Custom/TextField";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FormControl from "@material-ui/core/FormControl";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Radio from "@material-ui/core/Radio";
import TextField from "@material-ui/core/TextField";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";

import GroupOutlinedIcon from "@material-ui/icons/GroupOutlined";
import AccessTimeOutlinedIcon from "@material-ui/icons/AccessTimeOutlined";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import LaunchOutlinedIcon from "@material-ui/icons/LaunchOutlined";
import Zoom from "@material-ui/core/Zoom";
import Tooltip from "@material-ui/core/Tooltip";
import ChildCareOutlinedIcon from "@material-ui/icons/ChildCareOutlined";
import MonetizationOnOutlinedIcon from "@material-ui/icons/MonetizationOnOutlined";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ImageList from "@material-ui/core/ImageList";
import ImageListItem from "@material-ui/core/ImageListItem";
import MembershipsList from "./MembershipsList";

import ServiceAddOptions from "./ServiceAddOptions";
import GoogleMapsAutocomplete from "@components/Dashboard/Pro/Shared/CRM/GoogleMapsAutocomplete";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

function ElevationScroll(props) {
	const { children, target, onElevationChange } = props; // `target` is a ref to the scrollable element
	const [elevated, setElevated] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (target.current) {
				const isElevated = target.current.scrollTop > 100;
				setElevated(isElevated);
				onElevationChange(isElevated);
			}
		};

		const scrollableElement = target.current;
		scrollableElement.addEventListener("scroll", handleScroll);

		return () => {
			scrollableElement.removeEventListener("scroll", handleScroll);
		};
	}, [target, onElevationChange]);

	// Define custom elevation styles
	const elevationStyle = elevated
		? {
				boxShadow: "0 2px 4px 0 rgba(13,22,25,.058)",
				backgroundColor: "#FFF",
		  }
		: {
				boxShadow: "none",
		  };

	// Apply custom styles to the children component
	return React.cloneElement(children, {
		style: { ...children.props.style, ...elevationStyle },
	});
}

const ServiceAdd = ({ open, onClose, ...props }) => {
	const classes = useStyles("BookingFunnel");

	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("xs"));

	const hasOptions = true;
	const hasLocations = true;

	const dialogContentRef = React.useRef(null);

	const [isElevated, setIsElevated] = useState(false);

	const handleElevationChange = (elevated) => {
		setIsElevated(elevated);
	};

	const serviceOptions = [
		{
			location: "In-studio",
			detail: "8330 Long Point Rd Unit E Houston, TX 77055",
			directions: true,
		},
		{
			location: "Online",
			detail: "Virtual session",
		},
		{
			location: "My location",
			detail: "You will provide the address",
		},
	];

	const [selectedOption, setSelectedOption] = useState(null);
	const [showError, setShowError] = useState(false);
	const listRef = useRef(null);

	const handleRadioChange = (event) => {
		setSelectedOption(event.target.value);
	};

	//

	const itemData = [
		{
			img: "https://greenleafhvac.net/wp-content/uploads/2022/12/ac-maintenance-servicing-outdoor-unit.jpg",
		},
		{
			img: "https://greenleafhvac.net/wp-content/uploads/2022/12/ac-maintenance-servicing-outdoor-unit.jpg",
		},
		{
			img: "https://greenleafhvac.net/wp-content/uploads/2022/12/ac-maintenance-servicing-outdoor-unit.jpg",
		},
	];

	const itemsToShow = fullScreen ? 2 : 3;

	// ServiceAddDetails

	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const toggleDialog = () => {
		setIsDialogOpen(!isDialogOpen);
	};

	const toggleBookingDialog = () => {
		setIsBookingDialogOpen(!isBookingDialogOpen);
	};
	//

	const [location, setLocation] = useState("");

	// Handle selection change
	const handleLocationChange = (event) => {
		setLocation(event.target.value);
	};

	// ServiceAddBooking

	const [isBookingDialogOpen, setIsBookingDialogOpen] = useState(false);

	//

	const handleAddToBooking = () => {
		if (!selectedOption) {
			// If no option is selected, show error and scroll to the list
			setShowError(true); // Show error message
			listRef.current.scrollIntoView({ behavior: "smooth", block: "start" }); // Scroll to the list
		} else {
			setIsBookingDialogOpen(!isBookingDialogOpen);
		}
	};

	// Close dialog

	const handleCloseClick = () => {
		onClose();
	};

	return (
		<Dialog
			scroll={"paper"}
			fullScreen={fullScreen}
			fullWidth={true}
			//maxWidth={"sm"}
			open={open}
			onClose={onClose}
			TransitionComponent={Transition}
			keepMounted
			classes={{
				paper: classes.dialogPaper,
				container: classes.dialogContainer,
			}}
			BackdropProps={{
				style: {
					backgroundColor: "rgba(182, 192, 205, 0.6)",
				},
			}}
		>
			<ElevationScroll
				target={dialogContentRef}
				onElevationChange={handleElevationChange}
				{...props}
			>
				<DialogTitle
					style={{
						minHeight: 64,
						textAlign: "left",
						display: "flex",
						alignItems: "center",
					}}
					disableTypography
				>
					{isElevated && (
						<Box
							fontSize={20}
							fontWeight={600}
							className={classes.serviceAddTitle}
						>
							Annual HVAC Maintenance
						</Box>
					)}
					<Box position={"absolute"} top={8} right={5}>
						<IconButton aria-label="close" onClick={handleCloseClick}>
							<CloseIcon />
						</IconButton>
					</Box>
				</DialogTitle>
			</ElevationScroll>
			<DialogContent
				dividers
				style={{ borderTop: "unset", paddingTop: 0 }}
				ref={dialogContentRef}
			>
				<Box mb={8}>
					<ImageList rowHeight={120} gap={8} cols={fullScreen ? 2 : 3}>
						{itemData.slice(0, itemsToShow).map((item) => (
							<ImageListItem
								key={item.img}
								cols={item.cols || 1}
								className={classes.imageList}
								classes={{ item: classes.imageList }}
							>
								<img src={item.img} />
							</ImageListItem>
						))}
					</ImageList>
				</Box>
				<Box
					fontWeight={600}
					fontSize={28}
					pb={3}
					maxWidth={"90%"}
					lineHeight={1.3}
				>
					Annual HVAC Maintenance
				</Box>
				{/* <Box fontSize={16}>
					$20.00+ ・ 45 min+ ・ Ages 2 &ndash; 4 yrs ・ Your location
				</Box> */}
				<Box py={5}>
					<Box display={"flex"} flexDirection={"column"} style={{ gap: 8 }}>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<ChildCareOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Ages:</div> 2
								&ndash; 4 yrs&nbsp;&nbsp;&bull;&nbsp;&nbsp;Adult participation
								required
							</div>
						</Box>

						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<AccessTimeOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Time:</div> 45
								min+
							</div>
						</Box>

						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<RoomOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Location:</div>
								8330 Long Point Rd Unit E Houston, TX 77055
							</div>
							<Tooltip
								enterDelay={200}
								title="Get directions"
								arrow
								TransitionComponent={Zoom}
								placement={"top"}
							>
								<a href="xxx" target="_blank" style={{ display: "flex" }}>
									<LaunchOutlinedIcon color="primary" fontSize="small" />
								</a>
							</Tooltip>
						</Box>
						<Box display={"flex"} alignItems={"flex-start"} style={{ gap: 12 }}>
							<MonetizationOnOutlinedIcon />
							<div className={classes.serviceClassDetail}>
								<div className={classes.serviceClassDetailSpan}>Price:</div>{" "}
								From $49
							</div>
						</Box>
					</Box>

					{/* <Box my={8}>
						<Divider light />
					</Box> */}

					{/* {!hasOptions && !hasLocations ? ( */}
					<>
						<Box maxWidth={"100%"} mt={6} mb={4}>
							<ShowMoreText
								lines={3}
								more="Show more"
								less=""
								className={classes.serviceDialogText}
								anchorClass={classes.serviceDialogButton}
								expanded={hasLocations ? false : true}
								truncatedEndingComponent={"... "}
							>
								<div className={classes.serviceDialogText}>
									<div class="SAMPLE HTML OUTPUT">
										<p>
											Yoga, music, art projects and sensory play. A peaceful,
											playful hour for you and your child.&nbsp;
										</p>
										<p>
											<strong>This session's theme is "Folktales"</strong>
										</p>
										<ul>
											{" "}
											<li>
												Class starts with 20 minutes of family yoga. Children
												and grownups will practice yoga poses, breathing
												techniques, emotional regulation strategies plus lots of
												dancing, silliness and parent-child bonding.
											</li>{" "}
											<li>
												Class starts with 20 minutes of family yoga. Children
												and grownups will practice yoga poses, breathing
												techniques, emotional regulation strategies plus lots of
												dancing, silliness and parent-child bonding.
											</li>{" "}
											<li>
												Class starts with 20 minutes of family yoga. Children
												and grownups will practice yoga poses, breathing
												techniques, emotional regulation strategies plus lots of
												dancing, silliness and parent-child bonding.
											</li>{" "}
											<li>
												Class starts with 20 minutes of family yoga. Children
												and grownups will practice yoga poses, breathing
												techniques, emotional regulation strategies plus lots of
												dancing, silliness and parent-child bonding.
											</li>{" "}
											<li>
												Then we'll make some art and play at sensory
												stations!&nbsp;
											</li>{" "}
											<li>
												Class is appropriately paced for young children. They
												are always welcome to observe or participate as much as
												they feel comfortable.
											</li>{" "}
											<li>
												Art is child-led. If you think your child doesn't like
												art activities, this is actually the perfect way to get
												them in touch with their creativity!&nbsp;
											</li>
											<br />
										</ul>
									</div>
								</div>
							</ShowMoreText>
						</Box>
					</>
					{/* ) : (
						<Box maxWidth={"100%"}>
							<div className={classes.showMoreText}>
								All skill-levels welcome. Our classes are developmentally
								appropriate for the ages listed. We advise all children to be
								the minimum age for the class by the season start date to set
								them up for success in our program. We advise all children to be
								the minimum age for the class by the season start date to set
								them up for success in our program. We advise all children to be
								the minimum age for the class by the season start date to set
								them up for success in our program.
							</div>
							<Link color="primary" onClick={toggleDialog}>
								Show more
							</Link>

							<ServiceAddDetails open={isDialogOpen} onClose={toggleDialog} />
						</Box>
					)} */}

					{hasLocations && (
						<>
							<div ref={listRef}>
								<Box my={8}>
									<Divider light />
								</Box>

								<Box fontSize={22} fontWeight={600} mb={1}>
									Select a location
								</Box>
								{showError ? (
									<Box
										color="#D50000"
										mb={2}
										display={"flex"}
										alignItems={"center"}
										style={{ gap: 8 }}
									>
										<ErrorOutlineIcon />
										<div>Please select an option.</div>
									</Box>
								) : (
									<Box mb={2} color={"grey.600"} fontSize={15}>
										Choose one
									</Box>
								)}
								<List>
									{serviceOptions.map((option, index) => (
										<ListItem
											key={index}
											button
											onClick={() => setSelectedOption(option.location)}
											classes={{
												root: classes.listItem,
												button: classes.listButton,
												container: classes.listItemContainer,
											}}
											disableGutters
										>
											<ListItemText
												classes={{
													primary: classes.listPrimary,
													secondary: classes.listSecondary,
													multiline: classes.listMultiline,
												}}
												primary={option.location}
												secondary={
													<>
														{option.detail}
														{option.directions && (
															<Box component={"span"} ml={2}>
																<Tooltip
																	enterDelay={200}
																	title="Get directions"
																	arrow
																	TransitionComponent={Zoom}
																	placement={"top"}
																>
																	<a href="xxx" target="_blank">
																		<LaunchOutlinedIcon
																			color="primary"
																			fontSize="small"
																		/>
																	</a>
																</Tooltip>
															</Box>
														)}
													</>
												}
											/>
											<ListItemSecondaryAction>
												<Radio
													color="primary"
													edge="end"
													checked={selectedOption === option.location}
													onChange={handleRadioChange}
													value={option.location}
												/>
											</ListItemSecondaryAction>
										</ListItem>
									))}
								</List>
								{selectedOption === "My location" && (
									<>
										<Box bgcolor={"#F7F7F7"} borderRadius={8} p={6} mb={6}>
											<Box fontSize={16} fontWeight={600} mb={1.5}>
												Enter service address
											</Box>
											<GoogleMapsAutocomplete
												placeholder={"Enter service address"}
											/>
										</Box>
									</>
								)}
							</div>
						</>
					)}
				</Box>
			</DialogContent>
			<DialogActions style={{ padding: 24 }}>
				<Box
					display={"flex"}
					flexDirection={"row"}
					justifyContent={"space-between"}
					width={"100%"}
					m={"0 auto"}
					maxWidth={600}
				>
					{/* <Box flexBasis={"48%"}>
						<Button
							fullWidth
							size={"large"}
							//onClick={declineOnClickHandler}
							variant="outlined"
							disableElevation
						>
							Cancel
						</Button>
					</Box> */}
					{/* <Box flexBasis={"48%"}> */}
					{hasOptions ? (
						<Button
							fullWidth
							onClick={hasLocations ? handleAddToBooking : toggleBookingDialog}
							size={"large"}
							variant="contained"
							color="primary"
							disableElevation
						>
							Next
						</Button>
					) : (
						<Button
							fullWidth
							onClick={handleCloseClick}
							size={"large"}
							variant="contained"
							color="primary"
							disableElevation
						>
							Add to booking
						</Button>
					)}
					<ServiceAddOptions
						open={isBookingDialogOpen}
						onClose={toggleBookingDialog}
					/>
					{/* </Box> */}
				</Box>
			</DialogActions>
		</Dialog>
	);
};

ServiceAdd.propTypes = {};
export default ServiceAdd;
